import httpFactory from '@adjust/dashboard-core/api/instance/http-factory';
import { GetAuditEventsResponse } from '@api/types';

const http = httpFactory({ baseURL: configurationURL.audit.baseUrl });

export const getAuditEvents = (
  offset: number,
  limit: number,
  isSuperAdmin: boolean,
  term = '',
): GetAuditEventsResponse => {
  const params = {
    'page[offset]': offset,
    'page[limit]': limit,
  };

  if (term) {
    params['filter[search]'] = term;
  }

  if (isSuperAdmin) {
    params['filter[with_internal]'] = isSuperAdmin;
  }

  return http.get(`/events`, { params }).then(response => response.data);
};
